// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1888":"41e17f1722ebfcb6","6162":"fa77493b749b300a"}[chunkId] + ".css";
};